var tcc = {};

//VerticalAccordion component
tcc.component = function(ele){
  return{
    //verticalAccordion
    verticalSlider : function(e){
      $(e).click(function(event){
        var parent = $(event.target).parent();
        while( !parent.hasClass( "js-slider-item" ) ){
          parent = parent.parent();
        };
        parent.toggleClass(" active").find("> ul").stop().slideToggle();
      });
    },
    //redirecting on dropdown
    paginationRedirect : function(e){
      $( e ).change(function() {
        if (this.value.indexOf("page") > -1) {
          window.location.href = this.value;
        }
      });
    },
    //Sizing Guide Popup -
    //Code could be modified to support a generic popup
    sizingGuidePopup: function(e){
      var title = $(e).attr( "data-title" ),
          content = $(e).attr( "data-content" ),
          mobileLink = $(e).attr( "data-mobile-link" );

      function closePopUp(){
        $( "#popup-container" ).removeClass( "active");
      };

      $(e).click(function(event){
        event.preventDefault();
        if($(window).width() > 600){
          $("#popup-container img").attr("src", content);
          $("#popup-container h2").append(title);
          $("#popup-container").addClass("active");
          $('html, body').animate({ scrollTop: 0 }, 'slow');
          $("#popup-content-close").click(closePopUp);
          $(".overlay").click(closePopUp);
        } else {
          window.open(mobileLink);
        }
      });
    }
  }
}();

$(document).ready(
  function() {
    'use strict';
    //verticalAccordion
    //add the id or the class of the wrapper in the array to use this feature
    if($( window ).width() > 768){
      $(".js-slider-item").addClass(" active");
    };

    var verticalSliderAry = [".js-slider-wrapper h3"];
    $.each(verticalSliderAry, function( index, value ) {
      tcc.component.verticalSlider(value);
    });

    //redirecting on dropdown
    var selectRedirectAry = [".js-changePagination-collection"];
    $.each(selectRedirectAry, function( index, value ) {
      tcc.component.paginationRedirect(value);
    });
  }
);
